import { Flex } from '@chakra-ui/react'
import { css } from '@emotion/react'
import { Pagination } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/react'

import SessionQ from '@/queries/SessionQ'
import type { Query } from '@/client/query'

import SessionBoxWithOutline from '../SessionBox/SessionBoxWithOutline'

const SessionCarousel: React.FC<{
  sessions: Query[]
}> = ({ sessions }) => {
  if (sessions.length === 0) {
    return null
  }

  return (
    <Flex
      direction="column"
      overflow="hidden"
      flex={1}
      css={css`
        .swiper {
          padding-bottom: 40px;
        }
      `}
    >
      <Swiper
        spaceBetween={25}
        slidesPerView={1}
        pagination={{ clickable: true }}
        watchOverflow
        style={{ width: '100%' }}
        breakpoints={{
          992: {
            slidesPerView: sessions.length > 1 ? 2 : 1,
          },
        }}
        loop={sessions.length > 1}
        loopAdditionalSlides={sessions.length}
        modules={[Pagination]}
      >
        {sessions.map(session => (
          <SwiperSlide key={session(SessionQ.id) ?? 0}>
            <SessionBoxWithOutline session={session} />
          </SwiperSlide>
        ))}
      </Swiper>
    </Flex>
  )
}

export default SessionCarousel
